import { TENANT } from '@/src/lib/core/config.ts';
import { BRANDING_ENABLED_PER_TENANT } from '@/src/lib/utils/constants.ts';
import { StoreTenant } from '@/src/lib/store/types.ts';
import { Branding } from '@/src/lib/utils/branding.types.ts';

export function getBrandingEnabled(): Branding {
  return BRANDING_ENABLED_PER_TENANT[TENANT as StoreTenant] ?? Branding.DEFAULT;
}

export function isBrandingTurckBannerEnabled(): boolean {
  return BRANDING_ENABLED_PER_TENANT[TENANT as StoreTenant] === Branding.TURCK_BANNER;
}
